import React from "react";
import { withLocalize } from "react-localize-redux";
import { isNullOrUndefined } from "../../store/storeFunctions";
import { apiGet, getHostApi } from '../../store/apiWrapper';
import { writeErr } from '../common/logger';
import Message from "../common/message";

import "./skyminder.scss";

const loginStatus = {
    new: 1,
    obtainingAuthData: 2,
    authDataObtained: 3,
    finished: 4,
    failed: 5
}

class SkyminderSsoComponent extends React.Component {
    state = {
        loginStatus: loginStatus.new,
        xml: null,
        token: null,
        url: null
    }

    render() {
        if (isNullOrUndefined(localStorage.skyminder_login_xml) || isNullOrUndefined(localStorage.skyminder_login_token))
            return null;

        if (this.state.loginStatus === loginStatus.failed) {
            return (
                <div className="justify-content-center vertical-center">
                    <div className="columns is-centered">
                        <Message type="error" message={this.props.translate("SkyMinder.SSO.Error")} />
                    </div>
                </div>
            )
        }

        return (null);
    }

    componentDidMount() {
        this.setState({ loginStatus: loginStatus.obtainingAuthData });
        apiGet(
            `${getHostApi()}/api/skyminder/auth`,
            {},
            (success) => {
                if (!isNullOrUndefined(success.data)) {
                    this.setState({ xml: success.data.xml, token: success.data.token, url: success.data.url, loginStatus: loginStatus.authDataObtained });
                } else
                    this.setState({ loginStatus: loginStatus.failed });
            },
            (error) => {
                writeErr(error);
                this.setState({ loginStatus: loginStatus.failed });
            }
        );
    }

    componentDidUpdate() {
        if (this.state.loginStatus === loginStatus.authDataObtained && !isNullOrUndefined(this.state.xml)
        && !isNullOrUndefined(this.state.token) && !isNullOrUndefined(this.state.url)) {
            this.setState({ loginStatus: loginStatus.finished });
            let form = document.createElement("form");
            form.setAttribute("method", "POST");
            form.setAttribute("action", this.state.url);

            let inputXml = document.createElement("input");
            inputXml.setAttribute("type", "hidden");
            inputXml.setAttribute("name", "XML");
            inputXml.setAttribute("value", this.state.xml);

            let inputToken = document.createElement("input");
            inputToken.setAttribute("type", "hidden");
            inputToken.setAttribute("name", "TOKEN");
            inputToken.setAttribute("value", this.state.token);

            form.appendChild(inputXml);
            form.appendChild(inputToken);

            document.body.appendChild(form);
            form.submit();
        }
    }
}

export default withLocalize(SkyminderSsoComponent);